export default __webpack_public_path__ + "static/media/new-analytics.fa5ec978.svg";